// extracted by css-extract-rspack-plugin
export default {"pureLink":"footer-fragment__PureLink_pureLink__G0LVq"};